module.exports = __webpack_public_path__ + "static/placeholder-ai-ci-75ee727f43396688deeec575803eec4c.png";